import { withWidth, WithWidth } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { ReactComponent as HomeIcon } from "assets/img/home.svg";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface Props extends RouteComponentProps, WithWidth {}

// Virtual parent breadcrumb segments for routes that don't encode their parent path in the URL
const virtualParentPaths: Record<string, Array<{ segment: string; routeTo: string }>> = {
  "create-new-project": [
    { segment: "manage-all-data", routeTo: "/manage-all-data" },
    { segment: "projects", routeTo: "/manage-all-data/projects" },
  ],
};

class BreadcrumbsV2 extends React.Component<Props> {
  render() {
    const { location, history, width } = this.props;

    // Check if current screen is small (xs or sm)
    const isSmDown = /xs|sm/.test(width);

    // Split the path into segments, excluding numbers
    const pathnames = location.pathname.split("/").filter((x) => x && !/\d/.test(x));

    // Map certain routes to custom labels
    const pathMap = {
      "projects-new": "project home",
      "manage-mapping-data": "users",
      "announcements-new": "new announcements",
    } as const;

    const paths = pathnames.map((item: string) =>
      item in pathMap ? pathMap[item as keyof typeof pathMap] : item
    );

    // Build effective segments, prepending virtual parents when needed
    type BreadcrumbSegment = { segment: string; routeTo: string; isVirtual: boolean };
    const effectiveSegments: BreadcrumbSegment[] = [];

    const firstSegment = pathnames[0];
    if (firstSegment && firstSegment in virtualParentPaths) {
      for (const parent of virtualParentPaths[firstSegment]) {
        effectiveSegments.push({ ...parent, isVirtual: true });
      }
    }

    for (let i = 0; i < pathnames.length; i++) {
      effectiveSegments.push({
        segment: paths[i],
        routeTo: "/" + pathnames.slice(0, i + 1).join("/"),
        isVirtual: false,
      });
    }

    const manageRoute = (routeTo: string, index: number) => {
      if (paths.length > 1) {
        if (index === paths.length - 2) {
          if(routeTo !=="/manage-all-data"){
            history.goBack();
          }
          if (routeTo === "/projects") history.goBack();
          if (routeTo ==="/manage-all-data") history.push(routeTo);
        } else {
          history.push(routeTo);
        }
      }
    };

    return (
      <div style={{ paddingLeft: isSmDown ? "1.75rem" : "2.75rem", paddingTop: isSmDown ? "0.5rem" : "0" }}>
        <span>
          <HomeIcon
            style={{ marginRight: "6px", cursor: "pointer" }}
            onClick={() => history.push("/associated-chains")}
          />
        </span>

        {effectiveSegments.map(({ segment, routeTo, isVirtual }, index) => {
          // Skip encrypted ID segment (segment after "project home") for real segments
          if (!isVirtual && index > 0 && effectiveSegments[index - 1].segment === "project home" && (segment !== "store-reset-status" && segment !== "my-feedback" && segment !== "downloads")) return null;

          const isLast = index === effectiveSegments.length - 1;

          const displayText = segment.startsWith("iris-")
            ? segment
                .replace(/^iris-/i, "IRIS-")
                .replace(/-/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase())
            : segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

          // Real segment index (excluding virtual parents) for manageRoute
          const realIndex = isVirtual ? -1 : index - effectiveSegments.filter((s, i) => s.isVirtual && i < index).length;

          return (
            <span key={routeTo}>
              {index > 0 ? (
                <ArrowForwardIosIcon
                  style={{
                    fontSize: "small",
                    padding: "1px",
                    marginLeft: "3px",
                    marginRight: "3px",
                  }}
                />
              ) : (
                "\u00A0"
              )}

              <span
                onClick={isLast ? undefined : isVirtual ? () => history.push(routeTo) : () => manageRoute(routeTo, realIndex)}
                style={{
                  cursor: isLast ? "default" : "pointer",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  letterSpacing: 0,
                  lineHeight: "20px",
                  color:
                    isVirtual
                      ? "#0D5BE1"
                      : index === effectiveSegments.length - 1 && pathnames.length > 1
                      ? "#0D5BE1"
                      : "black",
                }}
              >
                {displayText}
              </span>
            </span>
          );
        })}
      </div>
    );
  }
}

// Wrap with withWidth to get screen size and withRouter for routing props
export default withRouter(withWidth()(BreadcrumbsV2));
